import { Controller } from 'stimulus'

// "Ignore" on the Job Fields card's possible-duplicate-options chip:
// remembers the current clusters server-side (they resurface if a new
// variant appears), then drops the chip from the page.
export default class extends Controller {
  ignore() {
    const body = new URLSearchParams({ job_column_id: this.data.get('columnId') })
    fetch(this.data.get('url'), {
      method: 'POST',
      headers: { 'X-CSRF-Token': Rails.csrfToken(), Accept: 'application/json' },
      body
    })
      .then(r => (r.ok ? r.json() : Promise.reject(new Error(r.status))))
      .then(() => this.element.remove())
      .catch(() => {})
  }
}
